import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { cartActions } from "../actions";
import {
  Grid,
  Button,
  IconButton,
  Typography,
  Divider,
  Avatar,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ImageDetailModal from "../components/ImageDetailModal";
import OrderTotals from "../components/OrderTotals";
import PercentIcon from "@mui/icons-material/Percent";
import Disconts from "../components/Disconts";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import CreateIcon from "@mui/icons-material/Create";
import useTotals from "../hooks/useTotals";
import PopUp from "../components/PopUp";

const styles = {
  button: {
    color: "black",
    backgroundColor: "#B5CD7F",
    '&:hover': {
      backgroundColor: "#8BB85A",
    },
    "& .Mui-disabled": {
      backgroundColor: "grey",
    },
    width: "100%",
    marginTop: "1rem",
  },
  alignRight: {
    textAlign: "right",
  },
  price: {
    marginLeft: "2rem",
  },
  bold: {
    fontWeight: "bold",
  },
  closeButton: {
    position: "absolute",
    right: 10,
    top: 1,
    color: "inherit",
  },
  buttonVolver: {
    backgroundColor: "#ef9a9a",
    "&:hover": { backgroundColor: "#ef9a9a" },
    color: "black",
    float: "right",
    width: "40%",
    height: 35,
  },
  IconButton: {
    marginBottom: "10px",
    fontSize: "12px",
    color: "black",
    borderColor: "grey",
  },
};

const parseId = (id) => {
  return id.replace(/\//g, " - ");
};

export default function Cart({ isCheckout }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme()
  const mobile = useMediaQuery(theme.breakpoints.down("md"))
  const [open, setOpen] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [imageDetails, setImageDetails] = useState("");
  const [totalDesc, setTotalDesc] = useState([]);
  const [dataDisconts, setDataDisconts] = useState({
    data: {},
    show: false,
  });

  const { dynamicsId } = useSelector((state) => state.account);
  const { items } = useSelector((state) => state.cart);
  const { webOrderId } = useSelector((state) => state.cart);
  const { integrationId } = useSelector((state) => state.cart);
  const { roles } = useSelector((state) => state.account);
  const { subtotal } = useTotals(items, dynamicsId, totalDesc);

  function finderDesc(descuentos, row) {
    const descuento = descuentos.find(
      (item) => item.productId === row.productId
    );
    if (descuento) {
      const desc = descuento.desc;
      const descuentoAplicado =
        desc === 0 ? 0 : (row.unitPrice * (desc / 100)).toFixed(2);
      const subtotal =
        desc === 0 ? row.unitPrice : row.unitPrice * (1 - desc / 100);
      return { descuento: descuentoAplicado, subtotal };
    } else {
      return { descuento: 0, subtotal: 0 };
    }
  }

  const imagenes = (params) => {
    setOpen(true);
    setImageDetails(params);
  };
  useEffect(() => {
    localStorage.setItem("cartItems", JSON.stringify(items));
    localStorage.setItem("orderItems", []);
  }, [items]);

  const onDeleteClick = (id) => {
    const updateDesc = totalDesc.filter((prod) => prod.productId !== id);
    setTotalDesc(updateDesc);
    dispatch(cartActions.removeItem(id));
  };

  const checkout = () => {
    if (subtotal < 426000) {
      return setShowMsg(true);
    }
    navigate("/checkout", { state: totalDesc });
  };

  const disabledCheckout =
    items.length === 0 || roles === "Vendedor" || webOrderId !== null;

  if (isCheckout) {
    return (
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "space-around",
          gap: "20px"
        }}
      >
        <Box sx={{
          width: "100%",
          display: "flex",
          overflow: "scroll",
          flexDirection: "column",
          alignItems: !mobile && "center",
        }}>
          <Table stickyHeader sx={{
            width: "50%",
            "@media print": {
              width: "100% !important",
            },
          }} size="small">
            <TableHead>
              <TableRow>
                <TableCell align="center" />
                <TableCell align="center">Item</TableCell>
                <TableCell align="center">Descripción</TableCell>
                <TableCell align="center">Cantidad</TableCell>
                <TableCell align="center">Su precio Unit</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((product, i) => (
                <TableRow key={product.productId} sx={{
                  '&:hover': {
                    backgroundColor: '#f2f2f2',
                  },
                }}>
                  <TableCell>{i + 1}</TableCell>
                  <TableCell>{product.productId}</TableCell>
                  <TableCell>{product.productDescription}</TableCell>
                  <TableCell>{product.quantity < 0 ? 0 : product.quantity}</TableCell>
                  <TableCell>
                    {
                      <>
                        {finderDesc(totalDesc, product).subtotal
                          ? finderDesc(totalDesc, product).subtotal.toFixed(2)
                          : ""}
                        <Disconts
                          row={product}
                          setTotal={setTotalDesc}
                          totalDesc={totalDesc}
                          isSubtotal={true}
                        />
                      </>}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <Box sx={{ width: "%" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box display={"flex"}>
                <Typography variant="h5" gutterBottom>
                  Totales
                </Typography>

              </Box>
              <Divider style={{ marginBottom: "1em" }} />
            </Grid>
            <Grid item xs={12}>
              <OrderTotals dynamicsId={dynamicsId} totalDesc={totalDesc} />
            </Grid>
          </Grid>
        </Box>
        <Disconts
          row={dataDisconts}
          setter={setDataDisconts}
          isSubtotal={false}
          totalDesc={totalDesc}
          setTotal={setTotalDesc}
          finder={finderDesc}
        />
      </Grid >
    );
  }

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={mobile ? 12 : 9} >
          {webOrderId !== null ? (
            <Typography variant="h6" gutterBottom>
              Esta editando la orden numero {`${integrationId ? integrationId : webOrderId}`}
              <Button
                size="small"
                style={styles.buttonVolver}
                onClick={() => {
                  dispatch(cartActions.clear());
                  navigate("/menu", { state: 3 });
                }}
              >
                Volver a pedidos
              </Button>
            </Typography>
          ) : (
            <Button
              onClick={() => {
                dispatch(cartActions.setIntegrationId(""));
                navigate("/");
              }}
              variant="outlined"
              style={styles.IconButton}
              startIcon={<ChevronLeftIcon />}
            >
              Volver
            </Button>
          )}
          <Box sx={{
            overflow: "scroll",
            '& .header-color-grid': {
              color: "black",
            }
          }}>
            <Table stickyHeader size={"small"}>
              <TableHead >
                <TableRow sx={{ color: "#9BCD65" }}>
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65", borderStartStartRadius: 5 }} />
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Item</TableCell>
                  {!mobile && <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Descripción</TableCell>}
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Cantidad</TableCell>
                  <TableCell align="center" sx={{ fontSize: "12px", backgroundColor: "#9BCD65" }}>Precio Lista</TableCell>
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Su Precio</TableCell>
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Editar</TableCell>
                  <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65" }}>Desc</TableCell>
                  {webOrderId === null && <TableCell align="center" sx={{ fontSize: mobile ? "12px" : "13px", backgroundColor: "#9BCD65", borderStartEndRadius: 5 }} />}
                </TableRow>
              </TableHead>
              <TableBody>
                {items.length > 0 ? items.map((product, i) => (
                  <TableRow key={product.productId} sx={{
                    '&:hover': {
                      backgroundColor: '#f2f2f2',
                    },
                  }}>
                    <TableCell>
                      <Avatar
                        variant="square"
                        size="small"
                        src={`${process.env.PUBLIC_URL}/assets/Catalogo/${parseId(
                          product.productId
                        )}.jpg`}
                        onClick={() => imagenes(product)}
                      />
                    </TableCell>
                    <TableCell align="center">{product.productId}</TableCell>
                    {!mobile && <TableCell align="center">{product.productDescription.length > 10
                      ? `${product.productDescription.substring(0, 20)}...`
                      : product.productDescription}</TableCell>}
                    <TableCell align="center">{product.quantity < 0 ? 0 : product.quantity}</TableCell>
                    <TableCell align="center">{product.unitPrice}</TableCell>
                    <TableCell align="center">
                      {finderDesc(totalDesc, product).subtotal
                        ? finderDesc(totalDesc, product).subtotal?.toFixed(2)
                        : ""}
                      <Disconts
                        row={product}
                        setTotal={setTotalDesc}
                        totalDesc={totalDesc}
                        isSubtotal={true}
                      />
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="inherit"
                        onClick={() =>
                          navigate(`/product-details/${encodeURIComponent(product.productId)}`, {
                            state: product.quantity,
                          })
                        }
                        size="large"
                      >
                        <CreateIcon />
                      </IconButton>
                    </TableCell>
                    <TableCell align="center">
                      <IconButton
                        color="inherit"
                        onClick={() =>
                          setDataDisconts({ data: product, show: !dataDisconts.show })
                        }
                        size="large"
                      >
                        <PercentIcon />
                      </IconButton>
                    </TableCell>
                    {webOrderId === null &&
                      <TableCell align="center">
                        <IconButton
                          color="inherit"
                          onClick={() => onDeleteClick(product.productId)}
                          size="large"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    }
                  </TableRow>
                )) :
                  <TableRow sx={{ height: 80 }}>
                    <TableCell colSpan={10} align="center">
                      <Typography variant="body1">
                        No se han agregado productos
                      </Typography>
                    </TableCell>
                  </TableRow>
                }
              </TableBody>
            </Table>
          </Box>
        </Grid>
        <Grid item xs={mobile ? 12 : 3}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h5" gutterBottom>
                Totales
              </Typography>
              <Divider style={{ marginBottom: "1em" }} />
            </Grid>
            <Grid item xs={12}>
              <OrderTotals dynamicsId={dynamicsId} totalDesc={totalDesc} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button
            sx={styles.button}
            variant="contained"
            onClick={checkout}
            disabled={disabledCheckout}
          >
            Checkout
          </Button>
        </Grid>
      </Grid >
      <ImageDetailModal
        image={imageDetails}
        open={open}
        onClose={() => setOpen(false)}
      />
      <PopUp
        msg={
          "El subtotal minimo de compra es de $426.000, por lo que no es posible procesar su pedido. Continué comprando..."
        }
        open={showMsg}
        setClose={setShowMsg}
      />
      <Disconts
        row={dataDisconts}
        setter={setDataDisconts}
        isSubtotal={false}
        totalDesc={totalDesc}
        setTotal={setTotalDesc}
        finder={finderDesc}
      />
    </>
  );
}
